import React, { useEffect, useRef } from "react";
import Assets from "../../Layouts/Assets";
import Style from "../MoneyExchange.module.scss";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useDimensions } from "../../../logic/Dimensions";

gsap.registerPlugin(ScrollTrigger);

const ExchangeImages = () => {
  const animtrigger = useRef();
  const { width } = useDimensions();
  useEffect(() => {
    const bnrappview = gsap.timeline({
      scrollTrigger: {
        trigger: `.${Style.imgsec}`,
        scrub: 2,
      },
    });
    if (width >= 1200) {
      bnrappview
        .to(`.${Style.shapewrap}`, {
          scrub: 2,
          y: -23,
          x: -20,
        })
        .to(`.${Style.imgwrap}`, {
          scrub: 2,
          rotation: -4,
          x: -30,
        });
    }
  });

  return (
    <div className={Style.imgsec} ref={animtrigger}>
      <div className={`${Style.appviewrap}`}>
        <figure className={Style.imgwrap}>
          <img src={Assets.exchangeimg01} alt="exchange" />
          <div className={Style.videoplay}>
            <video
              loop
              muted
              autoPlay={true}
              controls=""
              className={Style.videotag}
              playsInline
            >
              <source src={Assets.bnrvideo} type="video/mp4" />
            </video>
          </div>
        </figure>
        <div className={Style.shapewrap}>
          <span className={`${Style.shapes} ${Style.shapes_01}`}>$</span>
          <span className={`${Style.shapes} ${Style.shapes_02}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 960 835"
            >
              <path
                d="M85,0L99,20L110,44L118,72L123,101L125,137L124,292L37,291L17,283L0,270L0,299L3,315L12,337L28,357L40,366L60,374L125,376L124,459L34,458L17,450L0,436L0,465L3,482L11,502L27,523L42,534L61,541L125,544L125,701L123,738L117,770L109,795L96,820L85,834L436,833L512,824L576,808L627,788L666,767L701,742L738,707L762,677L785,640L805,596L822,542L924,543L943,551L959,564L959,535L953,509L942,489L929,475L919,468L898,459L849,459L833,457L834,375L924,376L939,382L959,397L958,360L954,345L946,328L929,308L904,294L821,291L810,255L795,217L765,164L746,139L723,114L672,73L644,56L591,32L529,14L479,5L420,0Z M678,543L670,582L659,617L637,664L607,705L582,729L554,749L523,765L497,775L432,789L404,792L250,791L251,543Z M251,376L687,376L688,456L687,458L434,459L250,457Z M251,41L389,41L443,45L501,58L530,69L553,81L578,98L603,121L636,165L653,199L666,235L678,285L677,291L250,291Z"
                fill="currentColor"
                fill-rule="evenodd"
              />
            </svg>
          </span>
          <span className={`${Style.shapes} ${Style.shapes_03}`}>₹</span>
          <span className={`${Style.shapes} ${Style.shapes_04}`}>£</span>
        </div>
      </div>
    </div>
  );
};

export default ExchangeImages;
